import React from 'react';
import ProductShowcase from '../components/ProductShowcase';
import FinalCTA from '../components/FinalCTA';

const Product = ({ siteContent }) => {
  const hero = siteContent?.productsPage?.hero;
  const products = siteContent?.productsPage?.products || [];

  return (
    <main className="bg-white pt-24">
      <section className="relative isolate overflow-hidden border-b border-[#e5e5e5] bg-[#171717] px-6 py-20 text-white md:py-28">
        <img
          src="https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=2200&auto=format&fit=crop"
          alt=""
          className="absolute inset-0 -z-20 h-full w-full object-cover"
        />
        <div className="absolute inset-0 -z-10 bg-[#171717]/80" />
        <div className="mx-auto max-w-7xl">
          <p className="mb-5 text-xs font-bold uppercase tracking-[0.2em] text-[#b9d2bc]">{hero?.eyebrow || 'Products'}</p>
          <h1 className="max-w-4xl text-4xl font-medium leading-tight md:text-6xl">{hero?.title || 'Explore our products'}</h1>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-white/70 md:text-xl">{hero?.description}</p>
        </div>
      </section>

      <ProductShowcase products={products} />
      <FinalCTA />
    </main>
  );
};

export default Product;
